(function () {
    'use strict';
    var m = angular.module('app');
    m.provider('routerV1Service', [
        '$routeProvider',
        function ($routeProvider) {
            this.routers = function (utils, resolvers) {
                return $routeProvider.when('/dashboard', {
                    templateUrl: utils.templatePath('dashboard', 'dashboard'),
                    controller: 'DashboardController',
                    title: utils.title('Dashboard'),
                    name: 'dashboard',
                    resolve: { currentUser: resolvers.currentUser }
                }).when('/dashboard/:module/', {
                    templateUrl: utils.templatePath('dashboard', 'dashboard'),
                    controller: 'DashboardController',
                    title: utils.title('Dashboard'),
                    name: 'dashboard',
                    resolve: { currentUser: resolvers.currentUser }
                }).when('/application/:module/:id*', {
                    templateUrl: utils.templatePath('dashboard', 'dashboard'),
                    controller: 'ApplicationProfileController',
                    title: utils.title('Application profile'),
                    name: 'application',
                    resolve: { currentUser: resolvers.currentUser }
                }).when('/user/:module/:id*', {
                    templateUrl: utils.templatePath('dashboard', 'dashboard'),
                    controller: 'UserProfileController',
                    title: utils.title('User profile'),
                    name: 'user',
                    resolve: { currentUser: resolvers.currentUser }
                }).when('/folder/:module/:id*', {
                    templateUrl: utils.templatePath('dashboard', 'dashboard'),
                    controller: 'FolderProfileController',
                    title: utils.title('Folder profile'),
                    name: 'folder',
                    resolve: { currentUser: resolvers.currentUser }
                }).when('/file/:module/:id*', {
                    templateUrl: utils.templatePath('dashboard', 'dashboard'),
                    controller: 'FileProfileController',
                    title: utils.title('File profile'),
                    name: 'file',
                    resolve: { currentUser: resolvers.currentUser }
                }).when('/email/:module/:id*', {
                    templateUrl: utils.templatePath('dashboard', 'dashboard'),
                    controller: 'EmailProfileController',
                    title: utils.title('Email profile'),
                    name: 'email',
                    resolve: { currentUser: resolvers.currentUser }
                }).when('/organization/:module/:id*', {
                    templateUrl: utils.templatePath('dashboard', 'dashboard'),
                    controller: 'OrganizationProfileController',
                    title: utils.title('Organization profile'),
                    name: 'organization',
                    resolve: { currentUser: resolvers.currentUser }
                }).when('/group/:module/:id*', {
                    templateUrl: utils.templatePath('dashboard', 'dashboard'),
                    controller: 'GroupProfileController',
                    title: utils.title('Group profile'),
                    name: 'group',
                    resolve: { currentUser: resolvers.currentUser }
                }).when('/site/:module/:id*', {
                    templateUrl: utils.templatePath('dashboard', 'dashboard'),
                    controller: 'SiteProfileController',
                    title: utils.title('Site profile'),
                    name: 'site',
                    resolve: { currentUser: resolvers.currentUser }
                }).when('/ip/:module/:id*', {
                    templateUrl: utils.templatePath('dashboard', 'dashboard'),
                    controller: 'IpProfileController',
                    title: utils.title('IP profile'),
                    name: 'ip',
                    resolve: { currentUser: resolvers.currentUser }
                }).when('/bucket/:module/:id*', {
                    templateUrl: utils.templatePath('dashboard', 'dashboard'),
                    controller: 'BucketProfileController',
                    title: utils.title('Bucket profile'),
                    name: 'bucket',
                    resolve: { currentUser: resolvers.currentUser }
                }).when('/project/:module/:id*', {
                    templateUrl: utils.templatePath('dashboard', 'dashboard'),
                    controller: 'ProjectProfileController',
                    title: utils.title('Project profile'),
                    name: 'project',
                    resolve: { currentUser: resolvers.currentUser }
                }).when('/iam-user/:module/:id*', {
                    templateUrl: utils.templatePath('dashboard', 'dashboard'),
                    controller: 'UserProfileController',
                    title: utils.title('IAM User profile'),
                    name: 'iam-user',
                    resolve: { currentUser: resolvers.currentUser }
                }).when('/iam-group/:module/:id*', {
                    templateUrl: utils.templatePath('dashboard', 'dashboard'),
                    controller: 'GroupProfileController',
                    title: utils.title('IAM Group profile'),
                    name: 'iam-group',
                    resolve: { currentUser: resolvers.currentUser }
                }).when('/instance/:module/:id*', {
                    templateUrl: utils.templatePath('dashboard', 'dashboard'),
                    controller: 'InstanceProfileController',
                    title: utils.title('Instance profile'),
                    name: 'instance',
                    resolve: { currentUser: resolvers.currentUser }
                }).when('/anomaly/:module/:id*', {
                    templateUrl: utils.templatePath('dashboard', 'dashboard'),
                    controller: 'AnomalyProfileController',
                    title: utils.title('Anomaly details'),
                    name: 'anomaly',
                    resolve: { currentUser: resolvers.currentUser }
                }).when('/viewer/:module/:id', {
                    templateUrl: utils.templatePath('viewer', 'viewer'),
                    controller: 'ViewerController',
                    title: utils.title('Viewer'),
                    name: 'viewer',
                    resolve: { currentUser: resolvers.currentUser },
                    reloadOnSearch: false
                }).when('/advanced-viewer/:module/:type/:preFilter', {
                    templateUrl: utils.templatePath('viewer', 'advanced-viewer'),
                    controller: 'AdvancedViewerController',
                    title: utils.title('Viewer'),
                    name: 'advanced-viewer',
                    resolve: { currentUser: resolvers.currentUser },
                    reloadOnSearch: false
                }).when('/auth/:page', {
                    templateUrl: utils.templatePath('auth', 'auth'),
                    controller: 'AuthController',
                    title: utils.title('Login'),
                    name: 'auth',
                    fullscreen: true,
                    resolve: {
                        userNotExist: resolvers.userNotExist,
                        featureResolver: resolvers.featureResolver
                    }
                }).when('/login', { redirectTo: '/auth/login' }).when('/password-reset', { redirectTo: '/auth/password-reset' }).when('/app-store/:filter', {
                    templateUrl: utils.templatePath('dashboard', 'dashboard'),
                    controller: 'AppStoreController',
                    title: 'Applications Store',
                    fullTitle: utils.title('<strong>Extend the avanan platform</strong> with these 3rd party services'),
                    name: 'app-store-filter',
                    accessor: 'appStore',
                    resolve: { currentUser: resolvers.currentUser }
                }).when('/app-store', {
                    templateUrl: utils.templatePath('dashboard', 'dashboard'),
                    controller: 'AppStoreController',
                    title: 'Applications Store',
                    fullTitle: utils.title('<strong>Extend the avanan platform</strong> with these 3rd party services'),
                    name: 'app-store',
                    accessor: 'appStore',
                    resolve: { currentUser: resolvers.currentUser }
                }).when('/cloud-apps', {
                    templateUrl: utils.templatePath('dashboard', 'dashboard'),
                    controller: 'AppStoreController',
                    title: utils.title('Cloud applications store'),
                    name: 'cloud-apps',
                    accessor: 'cloudApps',
                    resolve: { currentUser: resolvers.currentUser }
                }).when('/user-management', {
                    templateUrl: utils.templatePath('user-management', 'user-list'),
                    controller: 'UserListController',
                    title: utils.title('Users management'),
                    name: 'user-management',
                    resolve: { currentUser: resolvers.currentUser },
                    reloadOnSearch: false
                }).when('/wizard-user-management', {
                    templateUrl: utils.templatePath('user-management', 'user-list'),
                    controller: 'UserListController',
                    title: utils.title('Users management'),
                    name: 'wizard-user-management',
                    resolve: { currentUser: resolvers.currentUser },
                    reloadOnSearch: false,
                    fullscreen: true
                }).when('/configuration/dlp', {
                    templateUrl: utils.templatePath('configuration', 'dlp-configuration-list'),
                    controller: 'DlpConfigurationListController',
                    title: utils.title('Smart Search'),
                    name: 'dlp-configuration',
                    resolve: { currentUser: resolvers.currentUser },
                    reloadOnSearch: false
                }).when('/configuration/anomaly-detection', {
                    templateUrl: utils.templatePath('configuration', 'anomaly-detection-config'),
                    controller: 'AnomalyDetectionConfigController',
                    title: utils.title('Anomaly Detection'),
                    name: 'anomaly-detection',
                    resolve: { currentUser: resolvers.currentUser },
                    reloadOnSearch: false
                }).when('/report/create', {
                    templateUrl: utils.templatePath('report', 'report-create'),
                    controller: 'ReportCreateController',
                    title: utils.title('Report create'),
                    name: 'report-create',
                    resolve: { currentUser: resolvers.currentUser }
                }).when('/report/edit/:id', {
                    templateUrl: utils.templatePath('report', 'report'),
                    controller: 'ReportController',
                    title: utils.title('Report'),
                    name: 'report-edit',
                    resolve: { currentUser: resolvers.currentUser },
                    reloadOnSearch: false
                }).when('/report', {
                    templateUrl: utils.templatePath('report', 'report-list'),
                    controller: 'ReportListController',
                    title: utils.title('Reports'),
                    name: 'report-list',
                    resolve: { currentUser: resolvers.currentUser },
                    reloadOnSearch: false
                }).when('/policy/create', {
                    templateUrl: utils.templatePath('policy', 'policy-create'),
                    controller: 'PolicyCreateController',
                    title: utils.title('Query create'),
                    name: 'policy-create',
                    resolve: { currentUser: resolvers.currentUser },
                    internalModuleChange: false,
                    reloadOnSearch: false,
                    hideSaasSwitch: true
                }).when('/policy/edit/:id', {
                    templateUrl: utils.templatePath('policy', 'policy'),
                    controller: 'PolicyController',
                    title: utils.title('Query'),
                    name: 'policy-edit',
                    resolve: { currentUser: resolvers.currentUser },
                    reloadOnSearch: false,
                    hideSaasSwitch: true,
                    hiddenOverflow: true,
                    noPaddings: true
                }).when('/policy/dashboard', {
                    templateUrl: utils.templatePath('policy', 'policy-dashboard'),
                    controller: 'PolicyDashboardController',
                    title: utils.title('Queries dashboard'),
                    name: 'policy-dashboard',
                    resolve: { currentUser: resolvers.currentUser },
                    reloadOnSearch: false,
                    hideSaasSwitch: true
                }).when('/policy', {
                    templateUrl: utils.templatePath('policy', 'policy-list'),
                    controller: 'PolicyListController',
                    title: utils.title('Analytics'),
                    name: 'policy-list',
                    resolve: { currentUser: resolvers.currentUser },
                    reloadOnSearch: false,
                    hideSaasSwitch: true
                }).when('/policy/root-cause-view/:module/:id', {
                    templateUrl: utils.templatePath('policy', 'policy-root-cause-view'),
                    controller: 'PolicyRootCauseViewController',
                    title: utils.title('Query'),
                    name: 'policy-root-cause-view',
                    resolve: { currentUser: resolvers.currentUser },
                    reloadOnSearch: false
                }).when('/policy/allows/:id', {
                    templateUrl: utils.templatePath('policy', 'policy-allows'),
                    controller: 'PolicyAllowsController',
                    title: utils.title('Query allows'),
                    name: 'policy-allows',
                    resolve: { currentUser: resolvers.currentUser },
                    reloadOnSearch: false
                }).when('/drive-explorer/:module', {
                    templateUrl: utils.templatePath('advanced-data-search', 'advanced-data-search'),
                    controller: 'AdvancedDataSearchController',
                    title: utils.title('Drive explorer'),
                    name: 'drive-explorer',
                    resolve: { currentUser: resolvers.currentUser },
                    reloadOnSearch: false
                }).when('/mail-explorer/:module', {
                    templateUrl: utils.templatePath('advanced-data-search', 'advanced-data-search'),
                    controller: 'AdvancedDataSearchController',
                    title: utils.title('Mail Explorer'),
                    name: 'mail-explorer',
                    resolve: { currentUser: resolvers.currentUser },
                    reloadOnSearch: false
                }).when('/security-stack', {
                    templateUrl: utils.templatePath('dashboard', 'dashboard'),
                    controller: 'SecurityStackController',
                    title: utils.title('Security stack'),
                    name: 'security-stack',
                    resolve: { currentUser: resolvers.currentUser }
                }).when('/settings', {
                    templateUrl: utils.templatePath('settings', 'settings'),
                    controller: 'SettingsController',
                    title: utils.title('Settings'),
                    name: 'settings',
                    resolve: { currentUser: resolvers.currentUser }
                }).when('/wizard', {
                    templateUrl: utils.templatePath('wizard', 'wizard'),
                    controller: 'WizardController',
                    title: utils.title('Wizard'),
                    name: 'wizard',
                    fullscreen: true,
                    resolve: { currentUser: resolvers.currentUser }
                }).when('/alerts', {
                    templateUrl: utils.templatePath('alerts', 'alerts'),
                    controller: 'AlertsController',
                    title: utils.title('Alerts'),
                    name: 'alerts',
                    resolve: { currentUser: resolvers.currentUser },
                    reloadOnSearch: false
                }).when('/quarantine/:module/:type?', {
                    templateUrl: utils.templatePath('quarantine', 'quarantine'),
                    controller: 'QuarantineController',
                    title: utils.title('Quarantined Files'),
                    name: 'quarantine',
                    resolve: { currentUser: resolvers.currentUser },
                    reloadOnSearch: false
                }).when('/authorize-success', {
                    templateUrl: utils.templatePath('auth', 'authorize-error'),
                    controller: 'AuthorizeErrorController',
                    title: utils.title('Successful Service Authorization'),
                    name: 'authorize-error',
                    resolve: { featureResolver: resolvers.featureResolver },
                    fullscreen: true
                }).when('/authorize-error', {
                    templateUrl: utils.templatePath('auth', 'authorize-error'),
                    controller: 'AuthorizeErrorController',
                    title: utils.title('Service Authorization Error'),
                    name: 'authorize-error',
                    resolve: { featureResolver: resolvers.featureResolver },
                    fullscreen: true
                }).when('/:module/inline-policy/:type?', {
                    templateUrl: utils.templatePath('policy', 'inline-policy'),
                    controller: 'InlinePolicyController',
                    title: utils.title('Inline Query'),
                    name: 'inline-policy',
                    resolve: { currentUser: resolvers.currentUser },
                    internalModuleChange: false,
                    reloadOnSearch: false,
                    hideSaasSwitch: true
                }).when('/sec-app-stats', {
                    templateUrl: utils.templatePath('dashboard', 'dashboard'),
                    controller: 'SecAppStatsController',
                    title: utils.title('Security applications statistics'),
                    name: 'sec-app-stats',
                    resolve: { currentUser: resolvers.currentUser }
                }).when('/main-queue-stats', {
                    templateUrl: utils.templatePath('dashboard', 'dashboard'),
                    controller: 'MainQueueStatsController',
                    title: utils.title('Main queue statistics'),
                    name: 'main-queue-stats',
                    resolve: { currentUser: resolvers.currentUser }
                }).when('/download-history', {
                    templateUrl: utils.templatePath('dashboard', 'dashboard'),
                    controller: 'DownloadHistoryController',
                    title: utils.title('Download History'),
                    name: 'download-history',
                    resolve: { currentUser: resolvers.currentUser }
                }).when('/scan-monitor', {
                    templateUrl: utils.templatePath('dashboard', 'dashboard'),
                    controller: 'ScanMonitorController',
                    title: utils.title('Scanning status'),
                    name: 'scan-monitor',
                    resolve: { currentUser: resolvers.currentUser }
                }).when('/licenses', {
                    templateUrl: utils.templatePath('dashboard', 'dashboard'),
                    controller: 'LicensesController',
                    title: utils.title('Licenses status'),
                    name: 'licenses',
                    resolve: { currentUser: resolvers.currentUser }
                }).when('/system-log', {
                    templateUrl: utils.templatePath('dashboard', 'dashboard'),
                    controller: 'SystemLogController',
                    title: utils.title('System Log'),
                    name: 'system-log',
                    resolve: { currentUser: resolvers.currentUser }
                }).when('/entity-trend', {
                    templateUrl: utils.templatePath('dashboard', 'dashboard'),
                    controller: 'EntityTrendController',
                    title: utils.title('Entity trend'),
                    name: 'entity-trend',
                    resolve: { currentUser: resolvers.currentUser }
                }).when('/entity-per-user', {
                    templateUrl: utils.templatePath('dashboard', 'dashboard'),
                    controller: 'EntityPerUserController',
                    title: utils.title('Entity per user'),
                    name: 'entity-per-user',
                    resolve: { currentUser: resolvers.currentUser }
                }).when('/health-check', {
                    templateUrl: utils.templatePath('dashboard', 'dashboard'),
                    controller: 'HealthCheckController',
                    title: utils.title('Health Status'),
                    name: 'health-check',
                    resolve: { currentUser: resolvers.currentUser }
                }).when('/devices', {
                    templateUrl: utils.templatePath('devices', 'devices-list'),
                    controller: 'DevicesListController',
                    title: utils.title('Devices'),
                    name: 'devices-list',
                    resolve: { currentUser: resolvers.currentUser }
                }).when('/email-restore/:module/:msg', {
                    templateUrl: utils.templatePath('dashboard', 'dashboard'),
                    controller: 'EmailRestoreController',
                    title: utils.title('Email restore'),
                    name: 'email-restore',
                    resolve: { currentUser: resolvers.currentUser }
                }).when('/email-domains', {
                    templateUrl: utils.templatePath('settings', 'email-domains'),
                    controller: 'EmailDomainsController',
                    title: utils.title('Email Domains Management'),
                    name: 'email-domains',
                    resolve: { currentUser: resolvers.currentUser },
                    reloadOnSearch: false
                }).when('/learning-mode-state', {
                    templateUrl: utils.templatePath('dashboard', 'dashboard'),
                    controller: 'LearningModeStateController',
                    title: utils.title('Learning mode state'),
                    name: 'learning-mode-state',
                    resolve: { currentUser: resolvers.currentUser }
                }).when('/sec-tool-exceptions/:module/:type?', {
                    templateUrl: utils.templatePath('configuration', 'sec-tool-exceptions'),
                    controller: 'SecToolExceptionsController',
                    title: utils.title('Security Tools Exceptions'),
                    name: 'sec-tool-exceptions',
                    resolve: { currentUser: resolvers.currentUser },
                    reloadOnSearch: false
                }).when('/configuration/ap-exceptions/:type?', {
                    templateUrl: utils.templatePath('configuration', 'ap-avanan-exceptions'),
                    controller: 'ApAvananExceptionsController',
                    title: utils.title('Smart-Phish Exceptions'),
                    themeTitle: { sonicwallTheme: 'Anti-Phishing Exceptions' },
                    name: 'ap-avanan-exceptions',
                    resolve: { currentUser: resolvers.currentUser },
                    reloadOnSearch: false
                }).when('/inline-messages/:module/', {
                    templateUrl: utils.templatePath('troubleshooting', 'inline-messages'),
                    controller: 'InlineMessagesController',
                    title: utils.title('Inline messages'),
                    name: 'inline-messages',
                    resolve: { currentUser: resolvers.currentUser },
                    reloadOnSearch: false
                }).when('/inline-debug/:module/', {
                    templateUrl: utils.templatePath('troubleshooting', 'inline-debug'),
                    controller: 'InlineDebugController',
                    title: utils.title('Inline Emergency Options'),
                    name: 'inline-debug',
                    resolve: { currentUser: resolvers.currentUser },
                    reloadOnSearch: false
                }).when('/email-report/:reportId', {
                    templateUrl: utils.templatePath('dashboard', 'dashboard'),
                    controller: 'EmailReportController',
                    title: utils.title('Email Report'),
                    fullscreen: true,
                    hideMessenger: true,
                    name: 'email-report',
                    resolve: { currentUser: resolvers.currentUser }
                }).when('/system-config', {
                    templateUrl: utils.templatePath('settings', 'system-config'),
                    controller: 'SystemConfigController',
                    title: utils.title('System Configuration'),
                    name: 'system-config',
                    resolve: { currentUser: resolvers.currentUser }
                }).when('/password-change', {
                    templateUrl: utils.templatePath('auth', 'password-change'),
                    controller: 'PasswordChangeController',
                    title: utils.title('Change Password'),
                    name: 'password-change',
                    fullscreen: true
                }).when('/configuration/solgate-exceptions', {
                    templateUrl: utils.templatePath('configuration', 'solgate-exceptions'),
                    controller: 'SolgateExceptionsController',
                    title: utils.title('Solgate Exceptions'),
                    name: 'solgate-exceptions',
                    resolve: { currentUser: resolvers.currentUser },
                    reloadOnSearch: false
                }).when('/profile/:entityType/:id*', {
                    templateUrl: utils.templatePath('dashboard', 'dashboard'),
                    controller: 'ProfileController',
                    title: utils.title('Profile'),
                    name: 'profile',
                    resolve: { currentUser: resolvers.currentUser }
                }).otherwise({ redirectTo: '/dashboard' });
            };
            this.$get = [];
        }
    ]);
}());